import { composer } from '../../../component-decorators/composer';
import { Notification } from 'wix-style-react';
import React from 'react';
export var SupportModalSuccessNotification = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, show = _a.show;
    return (React.createElement(Notification, { show: show, theme: "success", type: "sticky" },
        React.createElement(Notification.TextLabel, null, t('manage-apps.support-modal.success-notification')),
        React.createElement(Notification.CloseButton, null)));
});
//# sourceMappingURL=support-app-success-notification.js.map